import * as React from 'react';
import { ILoginButtonProps } from './EServicesSiteHeader.types';
import { Icon } from 'sos-common/js/components/Icon/icon';

export const LoginButton: React.SFC<ILoginButtonProps> = (props) => (
  <button onClick={props.loginClickCallback} className="siteheader__button siteheader__button--login">
    <Icon iconType={props.iconType ? props.iconType : 'min-sida'} />
    <span>{props.buttonText}</span>
  </button>
);
